<div class="td-cnt-ext-incr">
    <div class="td-cnt-incr">
        <div class="td-cnt-title">
            <span class="te-title">{{'enquiryBook.increaseValue' | translate}} - {{columnLabel}}</span>
        </div>
        <div class="td-cnt-body-incr">
            <div class="inputs">
                <teiasoft-input [labelText]="'grid.Value' | translate" [isMobile]="isMobile" [disabled]="false"
                    [type]="'number'" [value]="inputValue" (onInput)="onInputValue($event)">
                </teiasoft-input>
                <teiasoft-select [labelText]="'grid.QuantityType' | translate" [isMobile]="isMobile" [disabled]="false"
                    [optionsList]="optionsList" [spaceLabel]="true" [noMinWidth]="true" [isValid]="true"
                    [readOnly]="false" [isRequired]="true" (onSelected)="onUnitChange($event.value)"
                    [defaultValue]="this.unit"></teiasoft-select>
            </div>
            <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
                <teiasoft-button (click)="closeModal()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                    [isMobile]="isMobile" class="mr-5"></teiasoft-button>
                <teiasoft-button (click)="applyIncrease()" [type]="'tb-primary'" [text]="'commons.apply' | translate"
                    [isMobile]="isMobile"></teiasoft-button>
            </div>
        </div>
    </div>